module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Diversion Books"), _c('br'), _vm._v("\n  A Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n  443 Park Avenue South, Suite 1008"), _c('br'), _vm._v("\n  New York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.DiversionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Copyright © 1987 by Ross H. Spencer"), _c('br'), _vm._v("\n  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("First Diversion Books edition March 2015"), _c('br'), _vm._v("\n  ISBN: 978-1-62681-613-8")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Also by Ross H. Spencer")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/morefrom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death Wore Gloves")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/morefrom",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Chance Purdue Series")]), _c('br'), _vm._v("\n  The Dada Caper"), _c('br'), _vm._v("\n  The Reggis Arms Caper"), _c('br'), _vm._v("\n  The Stranger City Caper"), _c('br'), _vm._v("\n  The Abu Wahab Caper"), _c('br'), _vm._v("\n  The Radish River Caper")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/morefrom",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Lacey Lockington Series")]), _c('br'), _vm._v("\n  The Fifth Script"), _c('br'), _vm._v("\n  The Devereaux File"), _c('br'), _vm._v("\n  The Fedorovich File")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To Sam Blake"), _c('br'), _vm._v("\n  for twenty-five years of unswerving friendship…"), _c('br'), _vm._v("\n  And to Shirley Spencer"), _c('br'), _vm._v("\n  for all that devotion.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("As Time’s inexorable gray tides sweep us to the vortex of Eternity we become given to looking back and, in the shade of retrospect, the things once perceived as small appear smaller, those recalled as large grow larger still, youth’s sadnesses seem infinitely sadder, its light moments lighter, bright-hued balloons of carnival-past, for nostalgia is a dewy-eyed old teller of tall tales, and memory warps as does the faulted mirror, enabling us to see with astonishing clarity that which never was…")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', [_vm._v("Monroe D. Underwood")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c02f54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/02_copy.vue
// module id = 63
// module chunks = 0